import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';
import SideBox from '../../components/SideBox/SideBox';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import ProductGridRow from '../../components/ProductGridRow/ProductGridRow';
import data from '../../data/displays.js';
import { Link } from 'react-router-dom';
import NextPage from '../../components/NextPage/NextPage';

class PageDisplays extends Component {

  render() {
    return (
        <Page primaryTitle="Displays" secondaryTitle="" section="displays">
            <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageDisplays">
                <p className="intro">Whether you need a simple branded table throw or a jaw-dropping 20x20 custom exhibit, SLA Service Management will take care of all of your exhibit needs. Contact us and we can discuss the best solution for you and your budget, or browse our product sheets for ideas, then call us for a price quote. SLA is here to help you - take advantage of us!</p>

                <ProductGrid caption="Displays">
                    <ProductGridRow data={data.custom_hybrid}>
                        <h4>Hybrids / Custom Builds</h4>
                        <p>You want your display to have the custom look of tension fabric graphics, durable aluminum extrusions, solid construction and elegant laminates, but you also want your display to be lightweight and portable to contain shipping and material handling costs. Well, you can have your cake and eat it, too! A hybrid or custom modular offers all of the cutting edge options to give your display a custom-made look, in lightweight materials and portable packaging to save shipping and handling costs.</p>
                    </ProductGridRow>

                    <ProductGridRow data={data.expanding_frame}>
                        <h4>Expanding Frame Displays</h4>
                        <p>These 3-dimensional, lightweight displays come in a variety of sizes and configurations to get you noticed. The fabric "skin" graphics can easily be changed in the field to customize your message to each event. Set up requires no tools or hired labor and is completed in seconds!</p>
                    </ProductGridRow>

                    <ProductGridRow data={data.navigator}>
                        <h4>Pillowcase Displays</h4>
                        <p>Bold tensioned fabric graphics wrap straight, curved or serpentine light weight frames in many sizes. Super easy to set up with no tools required! </p>
                    </ProductGridRow>

                    <ProductGridRow data={data.backlits}>
                        <h4>Backlits</h4>
                        <p>Perfect for permanent installations and portable enough for easy transport in trade show or event applications, our Backlits are universally appealing and will draw attention to YOU!</p>
                    </ProductGridRow>

                    <ProductGridRow data={data.rentals}>
                        <h4>Exhibit Rentals</h4>
                        <p>Yes, we have rentals available in a variety of sizes, configurations and layouts! Renting can really help stretch a modest budget with savings on upfront costs and storage fees. It's also a good way to try out a larger booth if you want to test out a bigger show presence. SLA is a dealer for  Classic Exhibits, which offers a <a href="https://www.classicexhibits.com/trade-show-display-rentals" target="_blank" rel="noopener noreferrer">vast catalog of rentals</a>. There are lots of possibilities, so give us a call and we'll help match you to the right one.</p>
                    </ProductGridRow>

                    <ProductGridRow data={data.bannerstands}>
                        <h4>Bannerstands &amp; Tablecloths</h4>
                        <p>Bannerstands and custom printed tablecloths are lightweight, portable displays that can be transported very easily and used singly or grouped to create an economical full size display. SLA has bannerstands in a variety of sizes and styles to fit your needs, including retractable, eco-friendly, and single or double-sided.</p>
                    </ProductGridRow>

                    <ProductGridRow data={data.seg}>
                        <h4>SEG Extrusion Systems</h4>
                        <p>The Silicone Edged Graphic (SEG) employs the process of sewing silicone strips around the perimeter of the graphic panel. The graphic edge inserts into the groove of an aluminum frame to create a taut, flat display with neatly finished corners. The frame can be self-standing, hung or mounted for a clean, minimalist effect. Use the SEG system to create room dividers, huge wall murals, tradeshow displays or to define a space.</p>
                    </ProductGridRow>

                    <ProductGridRow data={data.overhead}>
                        <h4>Overhead</h4>
                        <p>Look up! Increase your visibility by presenting your brand or message up high and from all directions with a hanging fabric structure. These skinned structures are constructed from the highest quality lightweight materials and are available in exciting shapes and sizes to meet any trade show or event need.</p>
                    </ProductGridRow>

                </ProductGrid>

                <NextPage page={this.props.page}/>

            </div>
            <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                <SideImage page={this.props.page} />
                <SideBox title="<span>Go GREEN</span> on your next display!">
                    <p>We offer environment-friendly 'green' options on any type of display, including:</p>
                    <ul>
                        <li><strong>Fabric panels</strong> created from recycled soda bottles and printed with water-based inks</li>
                        <li><strong>Framing</strong> constructed of FSC certified Performance Core with no formaldehyde added</li>
                        <li><strong>Wall</strong> and <strong>graphic panels</strong> constructed of certified "chain of custody" hp laminates</li>
                        <li><strong>Counter</strong> and <strong>tabletops</strong> created from 100% bamboo wood with no formaldehyde added</li>
                    </ul>
                    <p className="text-center">Read our <Link to="/environment">Environmental Statement</Link></p>
                </SideBox>
                <SideBox title="Custom Fabrication">
                    <Link to="/displays/custom_fabrication"><img src="/images/sidebox/custom_monitor_stand.png" alt="Custom Monitor Stand" /></Link>
                    <p><strong>If you need something unique, we can build it!</strong></p>
                    <Link to="/displays/custom_fabrication" className="btn btn-primary btn-block">View Samples</Link>
                </SideBox>
                <SideBox title="Don't see the product you are looking for?">
                    <p>SLA is a dealer for for these suppliers:</p>
                    <div className="text-center mb10">
                        <a href="https://www.orbus.com/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/sidebox/orbus-logo.webp" alt="Orbus" />
                        </a>
                    </div>
                    <div className="text-center mb10">
                        <a href="https://www.taylor.com/solutions/signs-and-graphics" target="_blank" rel="noopener noreferrer">
                            <img src="/images/sidebox/taylor-logo.svg" alt="Taylor Impressions" />
                        </a>
                    </div>
                    <div className="text-center mb10">
                        <a href="https://www.classicexhibits.com/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/sidebox/classic-exhibits.png" className="img-responsive" alt="Classic Exhibits" />
                        </a>
                    </div>
                    <p>Or <Link to="/contact">Contact us</Link> and we will respond with a solution that is sure to fit your needs!</p>
                </SideBox>
            </aside>
        </Page>
    );
  }
}

export default PageDisplays;



// WEBPACK FOOTER //
// ./src/pages/PageDisplays/PageDisplays.js